import {Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Advertising} from '../../../../../../domain/advertising/model/advertising';
import {SafeSubscriberDirective} from '../../../../../../application/app-context/safe-subscriber.directive';
import {AdvertisingDialogComponent} from '../../advertising-dialog.component';
import moment from 'moment';
import {App} from '../../../../../../domain/core/model/app';

@Component({
             selector: 'app-advertising-dialog',
             templateUrl: './create-or-modify-advertising-dialog.component.html',
             styleUrls: ['./create-or-modify-advertising-dialog.component.scss']
           })
export class CreateOrModifyAdvertisingDialogComponent extends SafeSubscriberDirective implements OnInit {

  @Output() createOrModifyEvent: EventEmitter<Advertising> = new EventEmitter<Advertising>();

  advertising: Advertising;
  duplicate: boolean;
  advertisingForm: FormGroup | undefined;
  @ViewChild('UploadFileInput') uploadFileInput: ElementRef;

  applications: Array<App>;
  requiredApplications: Array<string>;

  constructor(private formBuilder: FormBuilder,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<CreateOrModifyAdvertisingDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.advertising = data.advertising;
    this.duplicate = data.duplicate;
  }

  ngOnInit(): void {
    this.applications = App.allApps;
    this.advertisingForm = this.formBuilder.group({
        actif: this.formBuilder.control(this.advertising != null && !this.duplicate ? this.advertising.actif : false, Validators.required),
        title: this.formBuilder.control(this.advertising != null ? this.advertising.title : null, Validators.required),
        titleHtml: this.formBuilder.control(this.advertising != null ? this.advertising.titleHtml : null, Validators.required),
        chapeauHtml: this.formBuilder.control(this.advertising != null ? this.advertising.chapeauHtml : null),
        textHtml: this.formBuilder.control(this.advertising != null ? this.advertising.textHtml : null, Validators.required),
        startDate: new FormControl(this.advertising != null ? this.advertising.startDate : new Date(), Validators.required),
        endDate: new FormControl(this.advertising != null ? this.advertising.endDate : new Date(), Validators.required),
        actionBtLabel: this.formBuilder.control(this.advertising != null ? this.advertising.actionBtLabel : null),
        actionBtLink: this.formBuilder.control(this.advertising != null ? this.advertising.actionBtLink : null),
        fileBackground: this.formBuilder.control(this.advertising != null ? this.advertising.fileBackground : null),
        requiredApplications: this.formBuilder.control(this.advertising != null ? this.advertising.requiredApplications : null)
    });
    this.activateDesactivateActionBtLink(this.advertising?.actionBtLabel);
  }

  onSave(): void {
    if (!this.advertisingForm.valid) {
      return;
    }
    const advertising = this.advertisingForm.value as Advertising;
    this.normalizeDates(advertising);
    this.cleanActionBtLinkIfNoLabel(advertising);
    if (this.advertising) {
      advertising.id = this.advertising.id;
    }
    this.createOrModifyEvent.emit(advertising);
    this.closeDialog();
  }

  preview(): void {
    this.dialog.open(AdvertisingDialogComponent, {
      id: 'AdvertisingDialogComponent',
      width: '600px',
      height: '500px',
      data: {
        advertising: this.advertisingForm.value as Advertising,
        isPreview: true
      },
      panelClass: 'radius-mat-dialog'
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onChangeActionBtLabel(event): void {
    const value = event.currentTarget.value;
    this.activateDesactivateActionBtLink(value);
  }

  fileChangeEvent(fileInput: any): void {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          const imgBase64Path = e.target.result;
          this.advertisingForm.patchValue({
                                            fileBackground: imgBase64Path
                                          });
        };
      };
      reader.readAsDataURL(fileInput.target.files[0]);

      // Reset File Input
      this.uploadFileInput.nativeElement.value = '';
    }
  }

  private activateDesactivateActionBtLink(value): void {
    const actionBtLink = this.advertisingForm.get('actionBtLink');
    if (value !== '' && value !== null && value !== undefined) {
      actionBtLink.enable();
      actionBtLink.setValidators([Validators.required, Validators.minLength(1)]);
    } else {
      actionBtLink.disable();
      actionBtLink.setValidators(null);
    }
    actionBtLink.updateValueAndValidity();
  }

  private normalizeDates(advertising: Advertising): void {
    advertising.startDate = new Date(this.transformMomentToDate(advertising.startDate));
    advertising.endDate = new Date(this.transformMomentToDate(advertising.endDate));
  }

  private transformMomentToDate(dateAsMoment: any): string {
    const date = moment(dateAsMoment);
    return date.format('YYYY-MM-DD');
  }

  private cleanActionBtLinkIfNoLabel(advertising: Advertising): void {
    if (advertising.actionBtLabel === '' || advertising.actionBtLabel === null || advertising.actionBtLabel === undefined) {
      advertising.actionBtLink = null;
    }
  }

}
